module.exports = __webpack_public_path__ + "static/test.0e57b2cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/test.png
// module id = 448
// module chunks = 172923708597564 175449915206275